// export function unformat(value: string | undefined) {
//     if (!value) return undefined;
//     const floatValue = unformatInternal(value);
//     if (isNaN(floatValue)) return undefined;
//     return floatValue;
// }
/**
 * formatNumberIntl(10, 2) = 10.00
 * formatNumberIntl(10.2, 2) = 10.20
 * formatNumberIntl(10, 2, 0) = 10
 * formatNumberIntl(10.2, 2, 0) = 10.2
 */
export function formatNumberIntl(value, precision, minPrecision = precision) {
    if (value === undefined || value === null)
        return value;
    return Intl.NumberFormat(undefined, {
        style: "decimal",
        maximumFractionDigits: precision,
        minimumFractionDigits: minPrecision,
    }).format(value);
}
export function formatCurrencyIntl(value, precision, minPrecision = precision) {
    if (value === undefined || value === null)
        return value;
    return Intl.NumberFormat(undefined, {
        style: "currency",
        currency: "USD",
        currencySign: "accounting",
        maximumFractionDigits: precision,
        minimumFractionDigits: minPrecision,
    }).format(value);
}
export function formatPercentIntl(value, precision, minPrecision = precision) {
    if (value === undefined || value === null)
        return value;
    return Intl.NumberFormat(undefined, {
        style: "percent",
        maximumFractionDigits: precision,
        minimumFractionDigits: minPrecision,
    }).format(value);
}
